var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"currentColor","key":0}),React.createElement("path",{"d":"M18.5 22.667H10.1667V11.8337C10.1667 11.3753 9.79167 11.0003 9.33333 11.0003C8.875 11.0003 8.5 11.3753 8.5 11.8337V22.667C8.5 23.5837 9.25 24.3337 10.1667 24.3337H18.5C18.9583 24.3337 19.3333 23.9587 19.3333 23.5003C19.3333 23.042 18.9583 22.667 18.5 22.667ZM22.6667 19.3337V9.33366C22.6667 8.41699 21.9167 7.66699 21 7.66699H13.5C12.5833 7.66699 11.8333 8.41699 11.8333 9.33366V19.3337C11.8333 20.2503 12.5833 21.0003 13.5 21.0003H21C21.9167 21.0003 22.6667 20.2503 22.6667 19.3337ZM21 19.3337H13.5V9.33366H21V19.3337Z","fill":"white","key":1})]);
}

Copy.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
